<!-- 切换订单和配送单组件 -->
<template>
  <div class="tabs">
    <div class="tab" :class="{ active: value }" @click="$emit('input', true)">
      <div>
        {{ $fanyi("订单详情页面标题") }}
      </div>
    </div>
    <div class="tab" :class="{ active: !value }" @click="$emit('input', false)">
      <div>
        {{ $fanyi("Packinglist") }}&nbsp;<span class="count">
          ({{ porder_sn_set.length || 0 }})
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean, // v-model 绑定的值
  },
  data() {
    return {};
  },
  components: {},
  computed: {
    porder_sn_set() {
      return this.$parent.porder_sn_set;
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.tabs {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
  width: fit-content;
  font-family: Arial, sans-serif;
}

.tab {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 5px;
  &:first-child {
    padding-right: 0;
  }
  &:last-child {
    padding-left: 0;
  }
  div {
    @extend .dip;
    width: 160px;
    height: 40px;
    border-radius: 10px;
  }
}

.tab.active {
  div {
    background-color: #eaf8e8;
  }
}

.count {
  // color: #009246;
}
</style>
